import { Settings } from "./settings.ts";

type IModelDetails = {
    fitName: string;
    fitDescription: string;
    catalogShortDescription: string;
    catalogLongDescription: string;
    description: string;
    features: string[];
    faq: { question: string, answer: string }[];
    seoRank: number;
    imageCatalog: string;
}

export const ModelDetails: { [model: number]: IModelDetails; } = {
    501: {
        fitName: "Original",
        fitDescription: "Класичний прямий крій",
        catalogShortDescription: `
            <p>
                Levi’s 501 Original - класична модель чоловічих джинсів із прямим кроєм і середньою посадкою, що стала культовою на десятиліття. 
                Ці джинси поєднують традиційний стиль і повсякденний комфорт, залишаючись ідеальним вибором для чоловіків, які цінують класику.
            </p>
        `,
        catalogLongDescription: `
            <h2 class="fs-5">Чоловічі джинси Levi’s 501 Original Fit: Легенда деніму</h2>
            <p>Представляємо вашій увазі <strong>чоловічі джинси Levis 501 Original Fit</strong> - ту саму оригінальну модель, що стала прабатьком усіх сучасних джинсів. Створені у 1873 році, ці джинси є втіленням американського стилю та довговічності. Якщо ви шукаєте незмінну класику, яка ніколи не виходить з моди, обирайте <strong>Левіс 501</strong>.</p>
            <h3 class="fs-5">Ключові особливості моделі Левайс 501</h3>
            <p>Модель Левайс 501 має класичну посадку (Original Fit), яка ідеально підходить для будь-якого типу фігури. Вони сидять на талії або трохи вище, мають прямий крій до самого низу. Основні характеристики:</p>
            <ul>
                <li><strong>Культова ґудзик-ширінка:</strong> фірмова деталь 501-х, яка забезпечує надійну фіксацію та автентичний вигляд.</li>
                <li><strong>Прямий крій:</strong> штанина не звужується, що забезпечує класичний, розслаблений силует.</li>
                <li><strong>Висока якість матеріалів:</strong> доступні варіанти як зі 100% бавовни для класичного "жорсткого" деніму, так і з невеликим додаванням еластану (Stretch Denim) для додаткового комфорту.</li>
                <li><strong>Універсальність:</strong> джинси Левис 501 - це чисте полотно для самовираження, яке легко поєднується з будь-яким одягом та взуттям.</li>
            </ul>
            <h3 class="fs-5">Оригінальні джинси Levis 501 у каталозі ${Settings.shopName}</h3>
            <p>Ми пропонуємо широкий асортимент оригінальних джинсів <strong>Levis 501</strong> у різних кольорах. Кожна пара виготовлена з дотриманням стандартів якості Levi's, що підтверджується фірмовою фурнітурою та червоним ярликом (Red Tab).</p>
            <p>Оновіть свій гардероб непідвладною часу класикою. Замовляйте чоловічі джинси Левіс 501 вже сьогодні та відчуйте різницю між просто джинсами та легендою!</p>
        `,
        description: `
            <p>Легендарна класика у вашому гардеробі - чоловічі джинси <strong>Levi’s 501 Original Fit</strong> у фірмовому кольорі <strong>{{color}}</strong>. Ця модель у відтінку {{color}} втілює автентичний дух бренду, поєднуючи перевірений часом прямий крій та культову застібку на ґудзиках.</p>
            <p>Завдяки якісному деніму, джинси 501-ї серії у виконанні {{color}} чудово тримають форму та з часом набувають унікального вигляду, підлаштовуючись під вашу фігуру. Це універсальний вибір для тих, хто шукає надійність та стиль, що не підвладний часу.</p>
            <p>Обирайте оригінальні <strong>Levis 501</strong> у кольорі {{color}} - ідеальний фундамент для будь-якого образу. Замовляйте свою пару з гарантією справжності від виробника.</p>
        `,
        features: [
            "Крій: прямий",
            "Посадка: середня",
            "Кишені: п'ять кишень",
            "Застібка: гудзики"
        ],
        faq: [
            {
                question: "Яка посадка у чоловічих джинсів Levi’s 501?",
                answer: "Levi’s 501 мають класичну пряму посадку з середньою талією та широку штанину. Це оригінальна модель бренду, яка підходить для повсякденного та класичного стилю."
            },
            {
                question: "Чим відрізняються Levi’s 501 від 511?", 
                answer: "Levi’s 501 - це класичні прямі джинси з застібкою повністю на ґудзиках, а 511 - сучасна slim-модель із блискавкою, яка щільніше сидить по нозі. 501 - для класики, 511 - для міського стилю." 
            },
            {
                question: "Для якого типу фігури підходять Levi’s 501?",
                answer: "Levi’s 501 добре сидять на середніх та струнких чоловіках і надають класичний силует без облягання."
            },
            {
                question: "Чи можна носити Levi’s 501 щодня?",
                answer: "Так, вони виготовлені з міцного деніму і витримують щоденне носіння, залишаючись комфортними та стильними."
            }
        ],
        seoRank: 4,
        imageCatalog: "/img/jeans/501/catalog.jpg"
    },
    502: {
        fitName: "Taper",
        fitDescription: "Прямий крій зі звуженням донизу",
        catalogShortDescription: `
            <p>
                Levi’s 502 Taper - сучасна модель чоловічих джинсів із прямий кроєм трохи звуженим донизу, що поєднує комфорт та стиль. 
                Ці джинси ідеальні для чоловіків, які шукають більш сучасний силует, не втрачаючи класичної якості Levi’s.
            </p>
        `,
        catalogLongDescription: `
            <h2 class="fs-5">Чоловічі джинси Levi’s 502 Taper Fit: комфорт та сучасний стиль</h2>
            <p>Шукаєте ідеальну пару деніму, яка поєднує класичний крій та модний силует? Чоловічі джинси <strong>Levis 502 Taper Fit</strong> - це одна з найпопулярніших моделей у лінійці бренду. Завдяки продуманому крою, вони стали вибором номер один для тих, хто цінує універсальність. Якщо ви плануєте купити Левіс 502, ви отримаєте джинси, які однаково доречні як в офісі з сорочкою, так і на прогулянці з футболкою.</p>
            <h3 class="fs-5">Чому варто обрати Левайс 502?</h3>
            <p>Модель Левайс 502 вирізняється своєю особливою посадкою Regular Taper. Це означає, що вони мають стандартний об'єм у стегнах, як у класичних прямих моделях, але поступово звужуються від коліна до щиколотки. Така конструкція забезпечує:</p>
            <ul>
                <li><strong>Максимальний комфорт:</strong> додатковий простір у верхній частині не сковує рухів.</li>
                <li><strong>Сучасний вигляд:</strong> звужений низ штанини робить силует більш акуратним та дозволяє акцентувати увагу на взутті.</li>
                <li><strong>Середню посадку:</strong> джинси Левис 502 зручно сидять на талії, не сповзаючи та не створюючи дискомфорту.</li>
                <li><strong>Високу якість матеріалів:</strong> більшість моделей Levis 502 виготовляються з використанням еластичних волокон, що гарантує зручність і довговічність.</li>
            </ul>
            <h3 class="fs-5">Де купити оригінальні джинси Левис 502?</h3>
            <p>У каталозі ${Settings.shopName} представлений широкий вибір кольорів та обробок тканини. Обираючи джинси Левіс 502 у нас, ви отримуєте оригінальний товар з фірмовою фурнітурою та легендарним червоним табом на задній кишені.</p>
            <p>Замовляйте свою пару Levis 502 вже сьогодні та оцініть переваги культового деніму, який ніколи не виходить з моди!</p>
        `,
        description: `
            <p>Сучасна інтерпретація класики - чоловічі джинси <strong>Levi’s 502 Taper</strong> у фірмовому кольорі <strong>{{color}}</strong>. Ця модель у відтінку {{color}} пропонує ідеальний баланс між комфортом у стегнах та акуратним завуженим низом штанини.</p>
            <p>Завдяки універсальному крою, джинси 502-ї серії у виконанні {{color}} виглядають стильно та візуально подовжують силует. Це ідеальний вибір для тих, хто шукає зручну повсякденну пару, яка однаково добре поєднується як з масивними черевиками, так і з легкими кросівками.</p>
            <p>Обирайте оригінальні <strong>Levis 502</strong> у кольорі {{color}} для створення актуального образу. Замовляйте свою пару з гарантією якості та швидкою доставкою.</p>
        `,
        features: [
            "Крій: прямий зі звуженням донизу",
            "Посадка: середня",
            "Кишені: п'ять кишень",
            "Застібка: блискавка, гудзик"
        ],
        faq: [
            {
                question: "Яка посадка у Levi’s 502?",
                answer: "Levi’s 502 мають трохи звужену донизу штанину і середню талію. Це сучасна taper-модель для повсякденного стилю."
            },
            {
                question: "Чим відрізняються Levi’s 502 від 501?",
                answer: "502 мають застібку на блискавці та більш звужену ногу, тоді як 501 - прямі джинси з ґудзиками."
            },
            {
                question: "Для якого типу фігури підходять Levi’s 502?",
                answer: "Модель підходить чоловікам з будь-якою статурою. Це найбільш збалансована модель по комфорту і зовнішньому вигляду."
            },
            {
                question: "Чи комфортні Levi’s 502 для довгого носіння?",
                answer: "Так, денім в цій моделі як правило еластичний і щільно тримає форму, не обмежуючи рухів."
            }
        ],
        seoRank: 1,
        imageCatalog: "/img/jeans/502/catalog.jpg"
    },
    505: {
        fitName: "Regular",
        fitDescription: "Комфортний прямий крій",
        catalogShortDescription: `
            <p>
                Levi’s 505 Regular - класична модель чоловічих джинсів із прямим кроєм і середньою посадкою, яка забезпечує комфорт і універсальність. 
                Ці джинси ідеально підходять для тих, хто цінує традиційний стиль Levi’s і хоче поєднувати його з повсякденним образом.
            </p>
        `,
        catalogLongDescription: `
            <h2 class="fs-5">Чоловічі джинси Levi’s 505 Regular Fit: Оригінальна класика на блискавці</h2>
            <p>Зустрічайте <strong>чоловічі джинси Levis 505 Regular Fit</strong> - оригінальну модель із застібкою-блискавкою, що з'явилася ще у 1967 році. Ці джинси відомі своєю універсальною посадкою та прямим кроєм штанини, що підходить практично до будь-якого типу статури. Якщо ви шукаєте класичні <strong>Левіс 505</strong>, які забезпечують комфорт та довговічність, ви знайшли ідеальний варіант.</p>
            <h3 class="fs-5">Ключові особливості моделі Левайс 505</h3>
            <p>Головна відмінність моделі Левайс 505 від культових 501-х - це <strong>надійна ширінка на блискавці</strong> замість ґудзиків. Джинси мають середню посадку на талії та трохи більше простору в стегнах для максимального комфорту.</p>
            <ul>
                <li><strong>Regular Fit:</strong> прямий крій, що забезпечує достатньо місця в стегнах.</li>
                <li><strong>Пряма штанина:</strong> від коліна до щиколотки штанина залишається прямою, створюючи збалансований та класичний силует.</li>
                <li><strong>Середня посадка:</strong> комфортний пояс сидить на природній лінії талії.</li>
                <li><strong>Практичність та матеріали:</strong> джинси Левис 505 часто виготовляються з додавання еластану (Stretch Denim) для зручності.</li>
            </ul>
            <h3 class="fs-5">Оригінальні джинси Levis 505 в Україні</h3>
            <p>У каталозі ${Settings.shopName} представлений широкий вибір оригінальних джинсів <strong>Levis 505</strong> в різноманітних кольорах. Обираючи у нас, ви гарантовано отримуєте автентичну продукцію з фірмовою фурнітурою та червоним табом (Red Tab) на задній кишені.</p>
            <p>Замовляйте чоловічі джинси Левіс 505 сьогодні та додайте до свого гардероба перевірену часом класику, яка поєднує комфорт, стиль та легендарну якість Levi's!</p>
        `,
        description: `
            <p>Класичний комфорт на кожен день - чоловічі джинси <strong>Levi’s 505 Regular Fit</strong> у фірмовому кольорі <strong>{{color}}</strong>. Ця модель у відтінку {{color}} є ідеальним вибором для поціновувачів традиційного прямого крою та зручної застібки на блискавці.</p>
            <p>Завдяки стандартній посадці в зоні стегон, джинси 505-ї серії у виконанні {{color}} забезпечують максимальну свободу рухів та бездоганний вигляд протягом усього дня. Пряма штанина та якісний денім роблять цю пару універсальною базою, що легко комбінується як з класичним, так і з кежуал одягом.</p>
            <p>Обирайте перевірену часом якість <strong>Levis 505</strong> у кольорі {{color}} - це надійне рішення для чоловічого гардероба. Замовляйте оригінальну модель із гарантією справжності бренду.</p>
        `,
        features: [
            "Крій: прямий",
            "Посадка: середня",
            "Кишені: п'ять кишень",
            "Застібка: блискавка, гудзик"
        ],
        faq: [
            {
                question: "Яка посадка у Levi’s 505?",
                answer: "Levi’s 505 мають класичну пряму посадку з середньою талією та застібкою на блискавці."
            },
            {
                question: "Чим відрізняються Levi’s 505 від 501?",
                answer: "505 мають блискавку замість ґудзиків, а також трохи вищу посадку."
            },
            {
                question: "Для кого підходять Levi’s 505?",
                answer: "Вони універсальні для всіх типів фігури і підходять для повсякденного носіння."
            },
            {
                question: "Чи можна носити Levi’s 505 у офісі?",
                answer: "Так, класичний крій і стриманий дизайн роблять їх підходящими для casual office-стилю."
            }
        ],
        seoRank: 3,
        imageCatalog: "/img/jeans/505/catalog.jpg"
    },
    511: {
        fitName: "Slim",
        fitDescription: "Злегка завужений крій по всій довжині",
        catalogShortDescription: `
            <p>
                Levi’s 511 Slim - сучасні злегка завужені джинси, що поєднують стиль і комфорт. 
                Модель ідеально підходить для повсякденного носіння та легко комбінується з футболками, сорочками та светрами. 
                Levi’s 511 користуються великою популярністю серед покупців.
            </p>
        `,
        catalogLongDescription: `
            <h2 class="fs-5">Чоловічі джинси Levi’s 511 Slim Fit: Сучасний завужений крій</h2>
            <p>Зустрічайте <strong>чоловічі джинси Levis 511 Slim Fit</strong> - одну з найпопулярніших сучасних моделей бренду із трендовим, обтічним силуетом. Ці джинси розроблені як чудова альтернатива облягаючим (skinny) моделям, забезпечуючи акуратний вигляд, але з додатковим комфортом для руху. Якщо ви шукаєте ідеальні <strong>Левіс 511</strong>, що пасують до будь-якого гардероба, ви знайшли їх.</p>
            <h3 class="fs-5">Ключові особливості моделі Левайс 511</h3>
            <p>Модель Левайс 511 має посадку трохи нижче талії та злегка завужений крій по всій довжині, від стегна до щиколотки. Це створює елегантний та "пошитий на замовлення" вигляд, який чудово поєднується як із кросівками, так і з класичними черевиками.</p>
            <ul>
                <li><strong>Slim Fit:</strong> завужений крій, який не обтягує занадто сильно.</li>
                <li><strong>Посадка нижче талії:</strong> комфортна середня/низька посадка для щоденного носіння.</li>
                <li><strong>Завужена штанина:</strong> штанина злегка звужується, що візуально подовжує силует.</li>
                <li><strong>Технологія Stretch:</strong> більшість варіантів Levis 511 виготовляються з додаванням еластану (Stretch Denim або Levi's Flex), що забезпечує гнучкість та комфорт протягом усього дня.</li>
            </ul>
            <h3 class="fs-5">Оригінальні джинси Левис 511 у каталозі ${Settings.shopName}</h3>
            <p>У нашому асортименті представлений широкий вибір оригінальних джинсів <strong>Левис 511</strong> у різних кольорах. Обираючи у нас Levis 511, ви отримуєте автентичну якість Levi's та гарантію довговічності.</p>
            <p>Замовляйте свою пару чоловічих джинсів Левіс 511 сьогодні та додайте до свого стилю сучасну класику, яка завжди в тренді!</p>
        `,
        description: `
            <p>Сучасний трохи завужений силует для вашого гардероба - чоловічі джинси <strong>Levi’s 511 Slim Fit</strong> у фірмовому кольорі <strong>{{color}}</strong>. Ця модель у відтінку {{color}} є ідеальним компромісом між класикою та облягаючим (skinny) кроєм, створюючи охайний та актуальний вигляд.</p>
            <p>Завдяки продуманій посадці, джинси 511-ї серії у виконанні {{color}} не обмежують свободу рухів. Акуратний силует штанини та якісний денім роблять цю пару універсальною базою, що однаково ефектно виглядає як з кедами, так і з класичними черевиками.</p>
            <p>Обирайте стильну лаконічність <strong>Levis 511</strong> у кольорі {{color}} - це вибір тих, хто цінує сучасні тренди та легендарну якість. Замовляйте оригінальну модель із гарантією справжності бренду.</p>
        `,
        features: [
            "Крій: завужений",
            "Посадка: середня",
            "Кишені: п'ять кишень",
            "Застібка: блискавка, гудзик"
        ],
        faq: [
            {
                question: "Що означає посадка Slim у Levi’s 511?",
                answer: "Levi’s 511 щільніше сидять по нозі, зберігаючи комфорт у стегнах та колінах."
            },
            {
                question: "Чим Levi’s 511 відрізняються від 502?",
                answer: "511 - більш щільний slim fit, рівномірно звужується від стегон до щиколотки; 502 - вільніший і звужується лише в нижній частині, комфортніший для руху."
            },
            {
                question: "Для кого підходять Levi’s 511?",
                answer: "Для чоловіків, які хочуть сучасний slim-стиль. Ці злегка завужені джинси підходять для чоловіків середньої і стрункої статури."
            },
            {
                question: "Чи комфортні Levi’s 511 для щоденного носіння?",
                answer: "Так, вони виготовлені з еластичного деніму і зберігають форму навіть при активному використанні."
            }
        ],
        seoRank: 2,
        imageCatalog: "/img/jeans/511/catalog.jpg"
    },
    512: {
        fitName: "Slim Taper",
        fitDescription: "Завужений крій зі звуженням донизу",
        catalogShortDescription: `
            <p>
                Levi’s 512 Slim Taper - сучасна модель чоловічих джинсів із завуженим кроєм зі звуженням до щиколотки, що поєднує комфорт і елегантний силует. 
                Ідеальні для чоловіків, які хочуть сучасний вигляд, не втрачаючи класичної якості Levi’s.
            </p>
        `,
        catalogLongDescription: `
            <h2 class="fs-5">Чоловічі джинси Levi’s 512 Slim Taper: Найсучасніший силует</h2>
            <p>Шукаєте ідеальну посадку, що підкреслює фігуру? Чоловічі джинси <strong>Levis 512 Slim Taper</strong> - це втілення сучасного вуличного стилю. Ця модель поєднує в собі завужений крій у стегнах, як у класичних 511, з більш різким звуженням до щиколотки. Якщо ви плануєте купити <strong>Левіс 512</strong>, ви обираєте модель, яка найкраще пасує до кросівок та створює максимально чіткий силует.</p>
            <h3 class="fs-5">Головні переваги моделі Левайс 512</h3>
            <p>Модель Левайс 512 ідеально підходить чоловікам зі стрункою статурою або тим, хто віддає перевагу індивідуальному вигляду. Завдяки завуженій штанині, ці джинси виглядають дуже охайно та сучасно. Основні характеристики:</p>
            <ul>
                <li><strong>Slim Taper Fit:</strong> завужений крій у стегнах, що помітно звужується до самого низу.</li>
                <li><strong>Посадка нижче талії:</strong> сучасна низька/середня посадка для актуального вигляду.</li>
                <li><strong>Еластичність:</strong> джинси Левис 512 майже завжди виготовляються з додаванням еластану (технології Stretch або Levi's Flex), що дозволяє їм щільно прилягати до тіла, не обмежуючи рухів.</li>
                <li><strong>Універсальний стиль:</strong> Levis 512 однаково ефектно виглядають як з об'ємними худі, так і з приталеними сорочками.</li>
            </ul>
            <h3 class="fs-5">Де купити оригінальні джинси Левис 512?</h3>
            <p>У каталозі ${Settings.shopName} ви знайдете великий вибір оригінальних джинсів <strong>Levis 512</strong> у різноманітних кольорах. Кожна пара <strong>Левіс 512</strong> має фірмовий шкіряний патч та оригінальну фурнітуру, що гарантує справжність легендарного бренду.</p>
            <p>Обирайте свою ідеальну пару Levis 512 вже зараз та насолоджуйтесь преміальною якістю деніму, що створений для сучасного ритму життя!</p>
        `,
        description: `
            <p>Найсучасніший силует у лінійці бренду - чоловічі джинси <strong>Levi’s 512 Slim Taper</strong> у фірмовому кольорі <strong>{{color}}</strong>. Ця модель у відтінку {{color}} поєднує завужену посадку в стегнах із різким звуженням до щиколотки, створюючи максимально чіткий та актуальний вигляд.</p>
            <p>Завдяки інноваційному крою, джинси 512-ї серії у виконанні {{color}} ідеально лягають по фігурі та роблять акцент на вашому улюбленому взутті. Високоякісний денім із додаванням еластану забезпечує комфорт при досить щільній посадці, дозволяючи цій парі залишатися зручною базою для динамічного міського життя.</p>
            <p>Оберіть бездоганний стиль <strong>Levis 512</strong> у кольорі {{color}} для створення виразного сучасного образу. Замовляйте оригінальну модель із гарантією справжності від легендарного виробника.</p>
        `,
        features: [
            "Крій: завужений",
            "Посадка: середня",
            "Кишені: п'ять кишень",
            "Застібка: блискавка, гудзик"
        ],
        faq: [
            {
                question: "Що означає Slim Taper у Levi’s 512?",
                answer: "Levi’s 512 трохи завужені у стегнах і сильніше звужуються донизу, створюючи сучасний силует."
            },
            {
                question: "Чим відрізняються Levi’s 512 від 511?",
                answer: "512 схожі на 511 у верхній частині, але більш звужені від коліна вниз ніж 511."
            },
            {
                question: "Для кого підходять Levi’s 512?",
                answer: "Для чоловіків, які шукають slim-крою з більш завуженою нижньою частиною штанини. Ідеальні для чоловіків стрункої статури."
            },
            {
                question: "Чи можна носити Levi’s 512 щодня?",
                answer: "Так, модель комфортна для повсякденного та міського стилю."
            }
        ],
        seoRank: 6,
        imageCatalog: "/img/jeans/512/catalog.jpg"
    },
    514: {
        fitName: "Straight",
        fitDescription: "Сучасний прямий крій",
        catalogShortDescription: `
            <p>
                Levi’s 514 Straight - класична модель чоловічих джинсів із прямим кроєм від стегна до щиколотки, яка забезпечує комфорт і універсальність. 
                Ці джинси ідеальні для чоловіків, які цінують традиційний стиль Levi’s із сучасним підходом до посадки.
            </p>
        `,
        catalogLongDescription: `
            <h2 class="fs-5">Чоловічі джинси Levi’s 514 Straight Fit: Ідеальний баланс класики та комфорту</h2>
            <p>Шукаєте універсальні джинси з прямим кроєм, які не будуть ані занадто вузькими, ані занадто мішкуватими? Чоловічі джинси <strong>Levis 514 Straight Fit</strong> - це бестселер бренду, який забезпечує ідеальний баланс між комфортом та стилем. Ця модель сидить трохи нижче талії і чудово підходить чоловікам середньої та спортивної статури. Якщо ви плануєте купити <strong>Левіс 514</strong>, ви обираєте надійну класику на кожен день.</p>
            <h3 class="fs-5">Ключові особливості моделі Левайс 514</h3>
            <p>Модель Левайс 514 вирізняється своєю простою, але продуманою посадкою. Вона має прямий крій і штанину, яка зберігає однакову ширину від коліна до щиколотки.</p>
            <ul>
                <li><strong>Straight Fit:</strong> сучасний прямий крій, який забезпечує достатньо простору та не обмежує рухів.</li>
                <li><strong>Посадка нижче талії:</strong> комфортна середня посадка, що ідеально пасує до будь-якого гардероба.</li>
                <li><strong>Надійна ширінка на блискавці:</strong> зручна та практична застібка.</li>
                <li><strong>Технологія Stretch:</strong> багато варіантів Levis 514 виготовляються з додаванням еластану (наприклад, 99% бавовни та 1% еластану) для максимальної гнучкості та комфорту.</li>
            </ul>
            <h3 class="fs-5">Оригінальні джинси Левис 514 у каталозі ${Settings.shopName}</h3>
            <p>У нашому асортименті представлений широкий вибір оригінальних джинсів <strong>Левис 514</strong> у різноманітних кольорах. Кожна пара <strong>Левіс 514</strong> має фірмову фурнітуру, міцні шви та гарантію якості від Levi's.</p>
            <p>Обирайте свою ідеальну пару Levis 514 вже зараз та насолоджуйтесь перевіреною часом якістю деніму, що ніколи не виходить з моди!</p>
        `,
        description: `
            <p>Універсальна класика прямого крою - чоловічі джинси <strong>Levi’s 514 Straight Fit</strong> у фірмовому кольорі <strong>{{color}}</strong>. Ця модель у відтінку {{color}} пропонує ідеально збалансований силует: не надто вузький і не надто мішкуватий, що робить її незамінною базою гардероба.</p>
            <p>Завдяки стандартній посадці та прямій штанині, джинси 514-ї серії у виконанні {{color}} забезпечують повну свободу рухів та доречний вигляд у будь-якій ситуації. Це надійний вибір для тих, хто цінує традиційну якість Levis і шукає комфортну пару на кожен день.</p>
            <p>Обирайте перевірену часом якість <strong>Levis 514</strong> у кольорі {{color}} - ідеал прямого крою. Замовляйте оригінальну модель із гарантією справжності бренду.</p>
        `,
        features: [
            "Крій: прямий",
            "Посадка: середня",
            "Кишені: п'ять кишень",
            "Застібка: блискавка, гудзик"
        ],
        faq: [
            {
                question: "Яка посадка у Levi’s 514?",
                answer: "Levi’s 514 мають пряму посадку з середньою талією."
            },
            {
                question: "Чим відрізняються Levi’s 514 від 505?",
                answer: "514 трохи сучасніше, з нижчою посадкою ніж у Levi’s 505."
            },
            {
                question: "Для кого підходять Levi’s 514?",
                answer: "Для чоловіків, які шукають сучасні стильні прямі джинси."
            },
            {
                question: "Чи можна носити Levi’s 514 на роботу чи навчання?",
                answer: "Так, вони стримані, зручні та підходять для будь-якого casual-образу."
            }
        ],
        seoRank: 5,
        imageCatalog: "/img/jeans/514/catalog.jpg"
    },
    /*541: {
        fitName: "Athletic Taper",
        fitDescription: "Вільний крій зі звуженням донизу",
        catalogShortDescription: `
            <p>
                Levi’s 541 Athletic - джинси для чоловіків з більш широкими стегнами та прямим кроєм по нозі, що забезпечують комфорт і сучасний силует. 
                Ідеальні для тих, хто цінує свободу рухів і стильний вигляд.
            </p>
        `,
        catalogLongDescription: `
            <h2 class="fs-5">Чоловічі джинси Levi’s 541 Athletic Taper: Ідеальний крій для атлетів</h2>
            <p>Шукаєте джинси, які не тиснуть у стегнах, але виглядають сучасно? Чоловічі джинси <strong>Levis 541 Athletic Taper</strong> створені спеціально для чоловіків з атлетичною статурою. Ця модель вирішує головну проблему спортсменів: вона забезпечує додатковий простір там, де це необхідно, зберігаючи при цьому стильний завужений силует. Якщо ви плануєте купити <strong>Левіс 541</strong>, ви отримаєте ідеальний баланс між комфортом та естетикою.</p>
            <h3 class="fs-5">Чому варто обрати Левайс 541?</h3>
            <p>Модель Левайс 541 натхненна професійними атлетами. Вона має більш вільну посадку у верхній частині, що поступово звужується до щиколотки, створюючи охайний вигляд без зайвого об'єму тканини внизу. Основні характеристики:</p>
            <ul>
                <li><strong>Athletic Fit:</strong> розширений крій у зоні сидіння та стегон для максимальної свободи рухів.</li>
                <li><strong>Tapered Leg:</strong> штанина, що витончено звужується до низу, підкреслюючи спортивний силует.</li>
                <li><strong>Середня посадка:</strong> джинси Левис 541 зручно сидять на талії, забезпечуючи комфорт під час активного дня.</li>
                <li><strong>Технологічний денім:</strong> більшість моделей Levis 541 виготовляються з додаванням еластану (Levi's Flex), що дозволяє тканині розтягуватися та миттєво повертати форму.</li>
            </ul>
            <h3 class="fs-5">Оригінальні джинси Левис 541 у нашому каталозі</h3>
            <p>У нашому асортименті ви знайдете оригінальні джинси <strong>Levis 541</strong> у різних відтінках. Кожна пара <strong>Левіс 541</strong> має фірмову фурнітуру, міцні шви та легендарний шкіряний патч Levi's.</p>
            <p>Обирайте свою пару Levis 541 вже сьогодні - це найкращий вибір для тих, хто не хоче обирати між комфортом атлетичного крою та сучасним стилем!</p>
        `,
        description: `
            <p>Ідеальне рішення для атлетичної статури - чоловічі джинси <strong>Levi’s 541™ Athletic Taper</strong> у фірмовому кольорі <strong>{{color}}</strong>. Ця модель у відтінку {{color}} створена для тих, кому потрібен додатковий простір у стегнах без втрати сучасного завуженого силуету.</p>
            <p>Завдяки продуманому крою, джинси 541-ї серії у виконанні {{color}} забезпечують максимальну свободу рухів та комфорт протягом усього дня. Поєднання розслабленої посадки зверху та акуратного звуження штанини до низу робить цю пару універсальною базою для активного життя та стильних повсякденних образів.</p>
            <p>Обирайте комфортний атлетичний крій <strong>Levis 541</strong> у кольорі {{color}} - це вибір, що підкреслює вашу силу та стиль. Замовляйте оригінальну модель із гарантією якості від легендарного бренду.</p>
        `,
        features: [
            "Крій: вільний зі звуженням донизу",
            "Посадка: середня",
            "Кишені: п'ять кишень",
            "Застібка: блискавка, гудзик"
        ],
        faq: [
            {
                question: "Що означає Athletic Fit у Levi’s 541?",
                answer: "Levi’s 541 створені для чоловіків із розвиненими стегнами: більше простору у верхній частині, легке звуження донизу."
            },
            {
                question: "Кому підходять Levi’s 541?",
                answer: "Для чоловіків із спортивною або масивною статурою, які хочуть комфорт і сучасний вигляд."
            },
            {
                question: "Чим відрізняються Levi’s 541 від 514?",
                answer: "541 мають більше простору у стегнах і більш спортивну посадку з завуженням донизу, 514 - сучасні прямі джинси."
            },
            {
                question: "Чи можна носити Levi’s 541 щодня?",
                answer: "Так, вони зручні для активного використання і витримують повсякденне носіння."
            }
        ],
        seoRank: 7,
        imageCatalog: "/img/jeans/541/catalog.jpg"
    }*/
};